import { Make } from "./make";
import { MainGroup } from "./mainGroup";
import { Series } from "./series";

export class UpdateExistingNoiseCatalogRequest {
    noiseCatalogId?: number;
    noiseCatalogDisplayNumber?: string;
    noiseCatalogVimeoId?: string;
    make?: Make;
    mainGroup?: MainGroup;
    noiseCatalogDisplayId?: string;
    noiseCatalogTitle?: string;
    releaseDate?: string;
    views?: string;
    likes?: string;
    dislikes?: string
    isActive?: boolean;
    deactivateComments?: string;
    sporadicOrPermanent?: string;
    createdTs?: string;
    updatedTs?: string; //Only this needs to be modified.
    series?: Series[];
    sortingOrder?: string;
    bulletinDisplayNumber?: string[];
    noiseCatalogAreas?: string[];
    noiseCatalogComponents?: string[];
    noiseDrivingConditions?: string[];
    noiseNoiseTypes?: string[];
    noiseWeatherConditions?: string[];
   
}